import { jsxs, jsx } from "react/jsx-runtime";
import React__default from "react";
import { useFormContext } from "react-hook-form";
import { StyledSliderThumb, SliderLabel, Slider, token, StyledSliderTrack } from "@zillow/constellation";
import styled from "styled-components";
import { debounce } from "lodash";
import { event } from "@zillow/universal-analytics";
import AffordabilityDescription from "./AffordabilityDescription.esm.js";
import AffordabilityGraphic from "./AffordabilityGraphic.esm.js";
import { useLastValidAffordabilityValues, AFFORDABILITY_DTI_MAX, FieldConfig } from "../AffordabilityCalculator.utils.esm.js";
import { getWholeDollars, getCommaSeparatedNumber } from "../../../utils/zhl-calculator.esm.js";
import { trackLabel } from "../trackLabel.esm.js";
const handleFieldChange = debounce((label) => {
  const cmsInfo = {
    block_type_cd: "slider",
    block_id: "afffordability_calc",
    block_displayed_txt: label
  };
  sendInteractionEvent(cmsInfo);
}, 3e3);
const sendInteractionEvent = (cmsInfo) => {
  const newLaneData = {
    envelope: {
      event_type_id: "2056",
      event_type_version_id: "2",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_slider",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_engagement"
    },
    cms_info: cmsInfo
  };
  event(newLaneData);
};
const StyledSlider = styled(Slider).withConfig({
  displayName: "AffordabilityVisual__StyledSlider",
  componentId: "sc-15ej76z-0"
})(["", "{display:inline-flex;top:auto;bottom:-50px;white-space:nowrap;&::after{border-bottom:8px solid ", ";border-top:none;top:-32px;bottom:auto;margin-top:-8px;margin-bottom:0;}}", ":first-child{background-color:", ";}"], SliderLabel, token("colors.brand"), StyledSliderTrack, ({
  aggressive
}) => aggressive ? token("colors.caution") : token("colors.green300"));
const debouncedTrackSliderEdit = debounce(() => trackLabel("Slider Edit"), 1e3);
function AffordabilityVisual() {
  const form = useFormContext();
  const lastValidValues = useLastValidAffordabilityValues(form);
  return /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsx(AffordabilityDescription, { aggressive: lastValidValues.calculations.aggressive, affordabilityByDTI: lastValidValues.calculations.affordability.affordabilityByDTI }),
    /* @__PURE__ */ jsx(AffordabilityGraphic, { customPayment: lastValidValues.fields.customPayment, monthlyPayment: lastValidValues.fields.monthlyPayment, maximumPayment: lastValidValues.fields.maximumPayment, dti: lastValidValues.fields.dti }),
    /* @__PURE__ */ jsx(
      StyledSlider,
      {
        aggressive: lastValidValues.calculations.aggressive,
        id: "affordability-slider",
        min: 0,
        max: lastValidValues.fields.customPayment ? lastValidValues.fields.maximumPayment : AFFORDABILITY_DTI_MAX,
        value: lastValidValues.fields.customPayment ? lastValidValues.fields.monthlyPayment : lastValidValues.fields.dti,
        ariaValuetext: `${getWholeDollars(lastValidValues.calculations.affordability.monthlyPayment)} per month`,
        ariaLabel: "Monthly payment",
        renderThumb: (thumbProps) => /* @__PURE__ */ jsx(StyledSliderThumb, { ...thumbProps, children: /* @__PURE__ */ jsx(SliderLabel, { id: thumbProps.key, children: `${getWholeDollars(lastValidValues.calculations.affordability.monthlyPayment)}/mo` }) }),
        trackClassName: "affordability-track",
        onChange: (value) => {
          form.setValue(lastValidValues.fields.customPayment ? FieldConfig.monthlyPayment.name : FieldConfig.dti.name, getCommaSeparatedNumber(value), {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true
          });
          debouncedTrackSliderEdit();
          handleFieldChange("Affordability slider");
        }
      }
    )
  ] });
}
export {
  AffordabilityVisual as default
};
